var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 55,
    viewBox: "0 0 40 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 54,
    rx: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3536 16.6464C20.1583 16.4512 19.8417 16.4512 19.6464 16.6464L16.4645 19.8284C16.2692 20.0237 16.2692 20.3403 16.4645 20.5355C16.6597 20.7308 16.9763 20.7308 17.1716 20.5355L20 17.7071L22.8284 20.5355C23.0237 20.7308 23.3403 20.7308 23.5355 20.5355C23.7308 20.3403 23.7308 20.0237 23.5355 19.8284L20.3536 16.6464ZM19.6464 38.3536C19.8417 38.5488 20.1583 38.5488 20.3536 38.3536L23.5355 35.1716C23.7308 34.9763 23.7308 34.6597 23.5355 34.4645C23.3403 34.2692 23.0237 34.2692 22.8284 34.4645L20 37.2929L17.1716 34.4645C16.9763 34.2692 16.6597 34.2692 16.4645 34.4645C16.2692 34.6597 16.2692 34.9763 16.4645 35.1716L19.6464 38.3536ZM19.5 17L19.5 38L20.5 38L20.5 17L19.5 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.b3ac2162e81a4c6a5d8229b7f5acfc7e.svg";
export { ForwardRef as ReactComponent };